export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"facebook-domain-verification","content":"vw1qk37nyg3cief846abp3eqk7532u"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.ico"},{"rel":"dns-prefetch","href":"https://checkout.stripe.com"},{"rel":"dns-prefetch","href":"https://resource.auditoryworks.co"}],"style":[],"script":[{"children":"\n          if (window) {\n              const resize = () => {\n                  if (window.screen.availWidth < 1367) {\n                      document.documentElement.style.fontSize = \"14px\";\n                  } else {\n                      document.documentElement.style.fontSize = \"16px\";\n                  }\n              };\n          \n              window.addEventListener(\"resize\", resize);\n              resize();\n          }\n    "},{"innerHTML":"window.dataLayer = window.dataLayer || [];\n                function gtag(){dataLayer.push(arguments);}\n                gtag('js', new Date());\n\n                gtag('config', 'AW-11301612072', {'allow_enhanced_conversions':true});\n                ","type":"text/javascript"},{"innerHTML":"window.dataLayer = window.dataLayer || [];\n                function gtag(){dataLayer.push(arguments);}\n                gtag('js', new Date());\n\n                gtag('config', 'G-9PC0PSXWHY', {'allow_enhanced_conversions':true});\n        ","type":"text/javascript"},{"innerHTML":"\n                    window.dataLayer = window.dataLayer || [];\n                    function gtag(){dataLayer.push(arguments);}\n                    \n                    gtag(\"consent\", \"default\", {\n                        ad_storage: \"denied\",\n                        ad_user_data: \"denied\",\n                        ad_personalization: \"denied\",\n                        analytics_storage: \"denied\",\n                        region: [\"DE\"],\n                    });;\n                ","type":"text/javascript"},{"innerHTML":"(function(w, d, t, r, u) {\n            var f = function() {\n                var o = {ti: \"97114802\", enableAutoSpaTracking: true};\n                o.q = w[u] || [];\n                w[u] = new UET(o);\n                w[u].push(\"pageLoad\");\n            };\n\n            var loadScript = function() {\n                var n = d.createElement(t);\n                n.src = r;\n                n.async = true;\n                n.onload = f;\n                d.getElementsByTagName(\"head\")[0].appendChild(n);\n            };\n\n            setTimeout(loadScript, 5000); // 延迟 5 秒加载\n        })(window, document, \"script\", \"//bat.bing.com/bat.js\", \"uetq\");","type":"text/javascript"},{"innerHTML":"window.washengConfig = {\n                        reportUrl: \"https://www.nearhub.us/api-report/api/report\",\n                        brand: \"NearHub\"\n                    } ","type":"text/javascript"},{"async":true,"type":"text/javascript","src":"https://resource.auditoryworks.co/nearhub-v1/scripts/washeng-tracking-v2.global.js?t=1728464823191"}],"noscript":[{"innerHTML":"<img height=\"1\" width=\"1\" style=\"display:none;\" alt=\"\" src=\"https://px.ads.linkedin.com/collect/?pid=5307284&fmt=gif\" />"},{"innerHTML":"<noscript><img height=\"1\" width=\"1\" style=\"display:none\" src=\"https://www.facebook.com/tr?id=876197524220380&ev=PageView&noscript=1\"/></noscript>"}],"charset":"utf-8","title":"NearHub"}

export const appBuildAssetsDir = "/nuxt-static/"

export const appBaseURL = "/"

export const appCdnURL = "https://resource.auditoryworks.co/nearhub-v1/"

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"